import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Hong Yan`}</h1>
    <p>{`I'm a second year Computer Science student in University of Malaya majoring in Data Science`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      